import type { ThemeOptions } from '@mui/material';

import type { Theme } from '../themes';
import { createTheme as createBaseTheme } from './main';

const options = {
  palette: {
    divider: '#444444',
    action: {
      active: '#FFFFFF',
      hover: '#444444',
      focus: '#528BFF',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#BEBEBE',
      overline: '#BEBEBE',
      link: '#FFFFFF',
    },
    error: {
      main: '#FF6D6D',
    },
    background: {
      default: '#292929',
    },
  },
};

export function createTheme(...overrideTheme: ThemeOptions[]): Theme {
  return createBaseTheme(options, ...overrideTheme);
}

export const theme: Theme = createTheme();
